module.exports = __webpack_public_path__ + "static/media/icon_64.f06b9e36.svg";